import {
  StyledAutomationCard,
  StyledAutomationCardContent,
  StyledAutomationCardControls,
  StyledAutomationCardHead,
  StyledAutomationCardWrapper,
  StyledWarningInfo,
} from "../../containers/AutomationList/AutomationCards/AutomationCard/style";
import { IntegrationsIconList } from "../../containers/AutomationList/IntegrationsIconList";
import type { AutomationConfig } from "@smartsuite/automation-engine-api";
import { AutomationConfig_UserStatus } from "@smartsuite/automation-engine-api";
import { PhraseBuilder } from "../../components/PhraseBuilder";
import { PhraseBuilderWrapper } from "./style";
import type React from "react";
import { useState } from "react";
import { BasicOnOff, Icon, Paragraph } from "@smartsuite/react-ui/lib";
import { Colors } from "@smartsuite/types";
import { translateIfPresent } from "../../locales/i18n";
import { WHEN_BUTTON_IS_CLICKED_TRIGGER_ID } from "../../utils/constants";

export const ConfirmAutomationCard: React.FC<{
  automation: AutomationConfig;
  toggleStatus: (checked: boolean, automation: AutomationConfig) => void;
}> = ({ automation, toggleStatus }) => {
  const [isChecked, setIsChecked] = useState<boolean>(
    automation.userStatus === AutomationConfig_UserStatus.USER_ENABLED,
  );

  return (
    <StyledAutomationCardWrapper>
      <StyledAutomationCard style={{ margin: "0", borderRadius: 8 }}>
        <StyledAutomationCardHead>
          <IntegrationsIconList automation={automation} />
          <Paragraph
            size="s"
            styles={{
              position: "absolute",
              left: 180,
              zIndex: 1,
            }}
            transformMode="uppercase"
          >
            {automation.label}
          </Paragraph>
          <StyledAutomationCardControls
            style={{ position: "absolute", right: 20 }}
          >
            <BasicOnOff
              isChecked={isChecked}
              size="m"
              onChange={(e) => {
                toggleStatus(e, automation);
                automation.userStatus =
                  automation.userStatus ===
                  AutomationConfig_UserStatus.USER_ENABLED
                    ? AutomationConfig_UserStatus.USER_DISABLED
                    : AutomationConfig_UserStatus.USER_ENABLED;
                setIsChecked(!isChecked);
              }}
            />
          </StyledAutomationCardControls>
        </StyledAutomationCardHead>
        <StyledAutomationCardContent>
          <PhraseBuilderWrapper>
            <PhraseBuilder automation={automation} />
          </PhraseBuilderWrapper>
        </StyledAutomationCardContent>
      </StyledAutomationCard>
      {automation.trigger?.triggerReference?.triggerId ===
        WHEN_BUTTON_IS_CLICKED_TRIGGER_ID && (
        <StyledWarningInfo>
          <Icon name="important-lined" color={Colors.bRed}></Icon>
          <span>
            {translateIfPresent(
              "confirm-modal.delete-button-automation",
              "Note that this will also deleted the paired button as well",
            )}
          </span>
        </StyledWarningInfo>
      )}
    </StyledAutomationCardWrapper>
  );
};
